import { useCallback } from 'react';

import { useDownloadOrder as useDownloadOrderApi } from 'api/requests';
import { OrderEntity } from 'api/types/entity';
import { downloadBase64File } from 'helpers';
import { useServerErrorNotify } from 'hooks';

export const useDownloadOrder = (order: OrderEntity | null) => {
  const { downloadOrder, error } = useDownloadOrderApi();

  const onDownloadOrder = useCallback(async () => {
    if (!order) return;

    const res = await downloadOrder(order.id);
    if (res) {
      downloadBase64File(res, 'application/pdf');
    }
  }, [downloadOrder, order]);

  useServerErrorNotify(error);

  return {
    onDownloadOrder,
  };
};
